export async function apiFetch(path: string, init: RequestInit = {}) {
  const res = await fetch(`/api${path}`, { credentials: 'same-origin', ...init });
  if (res.status === 401) {
    window.location.href = '/login';
    throw new Error('unauth');
  }
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
